import React from "react";
import {Colors} from "../../styles";
import {moneyFormat} from "../../utils";
import {ComboStore} from "../../stores/combo/comboStore";
import * as ComboProvider from '../../services/combo';
import {Manager} from "../../core";
import {AccountStore} from "../../stores/account/accountStore";
export const gridOrderStatus = (props: { StatusBg: any; status: React.ReactNode; }) => {
  const status = String(props.status).toUpperCase();
  const isCanceled = status === 'CANCELED';
  const isDelivered = status === 'DELIVERED';
  const isPending = status === 'PENDING';
  
  const label = isCanceled ? 'Cancelado' : (isDelivered ? 'Entregue' : (isPending ? 'Pendente' : 'Ativo'));
  const color = isCanceled ? Colors.red : (isDelivered ? '#3498db' : (isPending ? '#f39c12' : Colors.green_light));
  
  return (<span
    style={{background: color, minWidth: 90, display: 'inline-block'}}
    className="text-white py-1 capitalize px-2 rounded-2xl text-md text-center font-bold"
  >
    {label}
  </span>);
};

export const gridOrderClientFormatter = (props: any) => {
  return (
    <span className="capitalize">{props.name} {props.surname}</span>
  );
};

export const gridOrderPaymentMode = (props: { StatusBg: any; payment: React.ReactNode; }) => {
  return (<span
    style={{background: Colors.green_light, width: 80, display: 'inline-block'}}
    className="text-white py-1 px-2 capitalize rounded-2xl text-md text-center"
  >
    {String(props.payment)}
  </span>);
};

export const gridOrderValueMode = (props: { StatusBg: any; value: React.ReactNode; }) => {
  return (<p
    className="py-1 px-2 capitalize rounded-2xl text-md"
  >
    {moneyFormat(props.value)}
  </p>);
};

export const contextMenuItems = [
  'AutoFit',
  'AutoFitAll',
  'SortAscending',
  'SortDescending',
  'Copy',
  'Edit',
  'Delete',
  'Save',
  'Cancel',
  'PdfExport',
  'ExcelExport',
  'CsvExport',
  'FirstPage',
  'PrevPage',
  'LastPage',
  'NextPage',
];
export const ordersGrid = [
  {
    field: 'payment',
    headerText: 'Meio de Pagamento',
    width: '150',
    template: gridOrderPaymentMode,
    textAlign: 'Center',
  },
  {
    field: 'id',
    headerText: 'ID do Plano',
    width: '100',
    editType: 'dropdownedit',
    textAlign: 'Center',
  },
  {
    field: 'name',
    headerText: 'Cliente',
    width: '180',
    template: gridOrderClientFormatter,
    textAlign: 'Left',
  },
  {
    field: 'plan',
    headerText: 'Plano',
    width: '100',
    editType: 'dropdownedit',
    textAlign: 'Center',
  },
  {
    field: 'value',
    headerText: 'Valor Contratado',
    width: '150',
    template: gridOrderValueMode,
    textAlign: 'Center',
  },
  {
    field: 'often',
    headerText: 'Frequência',
    width: '100',
    textAlign: 'Center',
  },
  {
    field: 'weekday',
    headerText: 'Dia da Semana',
    format: 'C2',
    textAlign: 'Center',
    editType: 'numericedit',
    width: '100',
  },
  {
    field: 'status',
    headerText: 'Status',
    width: '150',
    template: gridOrderStatus,
    textAlign: 'Center',
  },
  {
    field: 'hour',
    headerText: 'Hora',
    width: '100',
    textAlign: 'Center',
  },
  {
    field: 'date',
    headerText: 'Data de Início',
    width: '150',
    textAlign: 'Center',
  },
  {
    field: 'updatedAt',
    headerText: 'Atualizado em',
    width: '170',
    textAlign: 'Center',
  },
];
export const ordersData = [
  {
    id: 19,
    userId: "2",
    plan: "LIGHT",
    value: "160",
    often: "biweekly",
    weekday: "Monday",
    date: "2022/08/22",
    hour: "11:30am",
    bedrooms: 2,
    bathrooms: 1,
    middle: 1,
    ps: "Don’t move tv",
    payment: "CASH",
    status: "CANCELED",
    updatedAt: "2022-08-20 22:15:45"
  },
];
